import { colors } from "@literati/public-ui-shared-react";
import { css } from "styled-components";
import { BookShuffleCardDialogClassName } from "components/bookShuffle/BookShuffleCardDialog";

export const bookShuffleCardDialogTitleFontStyles = css`
  font-size: 1.125rem;
  font-weight: 700;
  color: ${colors.inkBlack};
`;

export const bookShuffleCardDialogDescriptionFontStyles = css`
  font-size: 0.9375rem;
  font-weight: 500;
  color: ${colors.warmGray3};
`;

export const bookShuffleCardDialogLayoutStyles = css`
  text-align: center;

  .${BookShuffleCardDialogClassName.CARD} {
    align-items: center;
  }
`;
